// FIN-11794 (Phase 2.2 GREEN) — pure helper for the typology-save dispatch payload.
//
// Extracted from handleSaveTypology in TypologiesTab/typologies.js so the
// payload shape is unit-testable without mounting TypologiesTab (which pulls
// in @react-awesome-query-builder + redux + saga deps). Mirrors the
// standalone-helper pattern used by ../utils/sortCatalogForPicker.
//
// Contract:
//   - { scenarioID, data: { typologyId, rules: <JSON string of variant projections> } }
//   - When savedVariantId is supplied (drawer-save path), data.savedVariantId
//     is set so the BE (FIN-11749) narrows validateRules to just that variant.
//   - When omitted (typology-level save buttons / legacy callers), the field
//     is left off — BE defaults to None and validates the full list.
// FIN-13286: a hard rule always scores 100, so its Score Override is locked in
// the drawer and dropped from the saved projection (covers rules stored with
// both set before the lock existed).
const projectScoringParameters = (scoringParameters) => {
  if (!scoringParameters || !scoringParameters.hardRule) {
    return scoringParameters;
  }
  // eslint-disable-next-line no-unused-vars
  const { scoreOverride, ...rest } = scoringParameters;
  return rest;
};

const buildSaveTypologyPayload = ({
  scenarioID,
  typology,
  savedVariantId
} = {}) => {
  const data = {
    typologyId: typology.typologyId,
    rules: JSON.stringify(
      typology.variants.map((variant) => ({
        ruleId: variant.ruleId,
        ruleName: variant.variantName,
        condition: variant.condition,
        function: variant.function,
        functionAggregation: variant.functionAggregation,
        matchAction: variant.matchAction,
        parameterMap: variant.parameterMap,
        // FIN-12208: carry the Scoring Overrides tab edits (scoreOverride +
        // hardRule). Omitting these from the projection dropped them from the
        // PUT body, so Score Override / Hard Rule never persisted and reverted
        // to catalog defaults on reopen. undefined is dropped by JSON.stringify,
        // so variants without overrides stay byte-for-byte as before.
        scoringParameters: projectScoringParameters(variant.scoringParameters),
        // FIN-13495: inputType (Variant Triggered On) must round-trip. It was
        // missing from this projection, so every save rewrote the stored rules
        // without it and the BE default (Transaction) took over — Activity
        // typologies silently flipped to Transaction and stopped alerting.
        // The scenario-local typologyId below is deliberate: the AFC id was
        // never meant to survive into scenario_typologies.rules.
        inputType: variant.inputType,
        typologyId: variant.typologyId,
        typologyName: variant.typologyName
      }))
    )
  };
  if (savedVariantId !== undefined) {
    data.savedVariantId = savedVariantId;
  }
  return { scenarioID, data };
};

export default buildSaveTypologyPayload;
